import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import AnimatedProgressBar from "../AnimatedProgressBar";
import { sendResubmitEvent } from "../../util/analytics/sendEvents";
import statusType from "../../util/requestStatuses";

export default function ReviewModal(props) {
  const {
    show,
    onGoBack,
    onConfirmSubmit,
    resetForm,
    ReviewComponent,
    userInput,
    messages,
    status
  } = props;

  // Set the appropriate message based on the request status
  const modalText = messages && messages[status];

  // Dynamically set the <ModalBody> and <ModalFooter> components based on the
  // requestStatus prop

  // TODO: Is there a better way to do this, so we're not redeclaring this
  // function on every render? This seems slow, but let's not micro-optimize...
  const components = (function setComponents(status) {
    // Show the user what they entered and ask them to confirm or go back and edit
    if (status === statusType.review) {
      return {
        body: <ReviewComponent request={userInput} />,
        footer: (
          <div>
            <Button color="primary" onClick={onConfirmSubmit}>
              Submit request
            </Button>{" "}
            <Button color="secondary" onClick={onGoBack}>
              Go back
            </Button>
          </div>
        )
      };
    }

    // Show a sugared progress bar once data has been sent off to the server
    if (status === statusType.pending) {
      return {
        body: <AnimatedProgressBar />,
        footer: null
      };
    }

    // Show our success message and prompt the user to submit a new request
    if (status === statusType.success) {
      return {
        body: modalText.description,
        footer: (
          <div>
            <Button color="primary" onClick={resetForm}>
              {modalText.action}
            </Button>{" "}
            <Button color="secondary" onClick={resetForm}>
              {modalText.secondary}
            </Button>
          </div>
        )
      };
    }

    // Show an error message and prompt user to edit their request or resend
    if (status === statusType.error) {
      return {
        body: modalText.description,
        footer: (
          <div>
            <Button
              color="primary"
              onClick={() => {
                sendResubmitEvent();
                onConfirmSubmit();
              }}
            >
              {modalText.action}
            </Button>{" "}
            <Button color="secondary" onClick={onGoBack}>
              {modalText.secondary}
            </Button>
          </div>
        )
      };
    }

    // Send back nothing as a default
    return {
      body: null,
      footer: null
    };
  })(status);

  // If we don't have data, don't rendering anything
  if (!modalText) {
    return null;
  }

  // Send back our all-purpose modal
  return (
    <Modal isOpen={show}>
      <ModalHeader>{modalText.title}</ModalHeader>
      <ModalBody>{components && components.body}</ModalBody>
      {components && components.footer ? (
        <ModalFooter>{components.footer}</ModalFooter>
      ) : null}
    </Modal>
  );
}

ReviewModal.displayName = "ReviewModal";

ReviewModal.propTypes = {
  // Controls whether our <Modal> is displayed or not
  show: PropTypes.bool.isRequired,
  // Object containing form data the user entered
  userInput: PropTypes.object.isRequired,
  // Object containing text elements for modal based on requestStatus
  messages: PropTypes.object.isRequired,
  // Callback to close modal and go back to editing the form
  onGoBack: PropTypes.func.isRequired,
  // Callback that will post userInput to our endpoint
  onConfirmSubmit: PropTypes.func.isRequired,
  // Close modal and go back to a clean form state
  resetForm: PropTypes.func.isRequired,
  // Component that knows how to display the userInput for review
  ReviewComponent: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/Shared/Modals/ReviewModal.js